"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _isBonusPlus = _interopRequireDefault(require("./isBonusPlus"));

var _isDeposit = _interopRequireDefault(require("./isDeposit"));

var _isMoneyBox = _interopRequireDefault(require("./isMoneyBox"));

var _isCredit = _interopRequireDefault(require("./isCredit"));

var _ProductMoneyBoxWhite = _interopRequireDefault(require("@p24/icons/ProductMoneyBoxWhite"));

var _ProductDepositWhite = _interopRequireDefault(require("@p24/icons/ProductDepositWhite"));

var _ProductCreditWhite = _interopRequireDefault(require("@p24/icons/ProductCreditWhite"));

var _ProductBonusPlusWhite = _interopRequireDefault(require("@p24/icons/ProductBonusPlusWhite"));

function _default(product) {
  if ((0, _isCredit["default"])(product)) {
    return _ProductCreditWhite["default"];
  } else if ((0, _isMoneyBox["default"])(product)) {
    return _ProductMoneyBoxWhite["default"];
  } else if ((0, _isDeposit["default"])(product)) {
    return _ProductDepositWhite["default"];
  } else if ((0, _isBonusPlus["default"])(product)) {
    return _ProductBonusPlusWhite["default"];
  } else {
    return null;
  }
}